import { AuthenticationInfoType } from "../../utility/types";
import { ProjectTimeLineItem } from "../PublishProject/types";
import ProjectTimeLineRow from "./ProjectTimeLineRow";

type ProjectTimeLineProps = {
  auth: AuthenticationInfoType;
  timeLine: ProjectTimeLineItem[];
  displayUTC: boolean;
};
const ProjectTimeLine = ({ auth, displayUTC, timeLine }: ProjectTimeLineProps) => {
  return (
    <div className="project-timeline">
      {timeLine.map((item) => {
        return (
          <>
            <ProjectTimeLineRow
              projectId={item.id}
              auth={auth}
              timeLineItem={item}
              displayUTC={displayUTC}
            ></ProjectTimeLineRow>
          </>
        );
      })}
    </div>
  );
};

export default ProjectTimeLine;
